export default "__VITE_ASSET__Cs4rr7_g__"